import { BasicCompany } from '@dieterApi/company/useCompanyQuery';

interface CelloNotificationProps {
  principalCompany?: BasicCompany;
}

export function CelloNotification({ principalCompany }: CelloNotificationProps) {
  if (!principalCompany?.celloReferralCode) return null;

  return (
    <div className="flex flex-col gap-2 mt-4 mb-6 items-center bg-pricing-yellow p-4 rounded-2xl border border-dieter-yellow-dark">
      <span className="text-lg font-bold text-dieter-black">🥳 YAY! Du wurdest geworben!</span>
      <span className="text-sm text-dieter-black">
        Beim Buchungsvorgang wird dir automatisch zusätzlich 25% Rabatt gewährt!
      </span>
    </div>
  );
}
